/**
 * @generated SignedSource<<1c7efe7289a64aeee024be64a70193b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomerPropertyLayout_property",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomerPropertyNavigation_property"
    }
  ],
  "type": "Property",
  "abstractKey": null
};

node.hash = "ff802b54b91740bfc3c26d89dcd52b1f";

export default node;
